import { useRef, useState } from 'react';
import { useFormik } from 'formik';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';

import { APP_VERSION } from '../../constants';
import { useAuth } from '../../context/AuthProvider';

import rctLogo from '../../images/RCTLogo.png';
import background from '../../images/background.jpg';

const Authorization = () => {
    const toast = useRef(null);
    const auth = useAuth();
    const [submitting, setSubmitting] = useState(false);

    const formik = useFormik({
        initialValues: { username: '', password: '' },
        validate: (values) => {
            const errors = {};

            if (!values.username.trim()) {
                errors.username = 'Введіть логін';
            }

            if (!values.password) {
                errors.password = 'Введіть пароль';
            }

            // Було: validate обчислював errors, але нічого не повертав,
            // тому перевірка полів ніколи не спрацьовувала.
            return errors;
        },
        onSubmit: async (values) => {
            setSubmitting(true);

            const status = await auth.loginAction(values);

            setSubmitting(false);

            if (status === 401) {
                formik.setFieldValue('password', '');
                toast.current?.show({
                    severity: 'error',
                    summary: 'Помилка авторизації',
                    detail: 'Неправильний логін або пароль',
                    life: 3000,
                });
            } else if (status) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Сервіс недоступний',
                    detail: `Не вдалося зв’язатися з сервером (код ${status})`,
                    life: 4000,
                });
            }
        },
    });

    const fieldError = (name) => formik.touched[name] && formik.errors[name];

    return (
        <>
            <Toast ref={toast} position="top-center" />
            <div className="rc-login">
                <div className="rc-login__panel">
                    <form className="rc-login__card" onSubmit={formik.handleSubmit} noValidate>
                        <div className="rc-login__brand">
                            <img className="rc-login__logo" src={rctLogo} alt="RCT" />
                            <div className="rc-login__wordmark">
                                RCT<em>CASH</em>
                            </div>
                            <div className="rc-login__hint">Вхід у касовий застосунок</div>
                        </div>

                        <div className="rc-field">
                            <label className="rc-field__label" htmlFor="username">
                                Логін
                            </label>
                            <InputText
                                id="username"
                                name="username"
                                autoComplete="username"
                                autoCapitalize="none"
                                autoCorrect="off"
                                value={formik.values.username}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={fieldError('username') ? 'p-invalid' : ''}
                            />
                            {fieldError('username') && (
                                <small className="rc-field-error">{formik.errors.username}</small>
                            )}
                        </div>

                        <div className="rc-field">
                            <label className="rc-field__label" htmlFor="password">
                                Пароль
                            </label>
                            <Password
                                inputId="password"
                                name="password"
                                autoComplete="current-password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                feedback={false}
                                toggleMask
                                className={fieldError('password') ? 'p-invalid' : ''}
                                inputClassName="w-full"
                                pt={{ root: { className: 'w-full' } }}
                            />
                            {fieldError('password') && (
                                <small className="rc-field-error">{formik.errors.password}</small>
                            )}
                        </div>

                        <Button
                            type="submit"
                            label="Увійти"
                            icon="pi pi-sign-in"
                            className="w-full"
                            loading={submitting}
                        />

                        <div className="rc-login__footer">
                            © 2024–{new Date().getFullYear()} Red Cat Tech · v{APP_VERSION}
                        </div>
                    </form>
                </div>

                <div
                    className="rc-login__art"
                    style={{ backgroundImage: `url(${background})` }}
                    aria-hidden="true"
                />
            </div>
        </>
    );
};

export default Authorization;
